import { InteractionTextSelection } from "../../../../src/examples/utilities/Interaction";
import * as React from 'react';
export default {
  InteractionTextSelection,
  React
};